// src/components/map/utils/networkLayerConstants.ts
//
// Shared Mapbox layer/source ID constants for network visualization.
// Used by useLocalNetworkMap, useNetworkVisualizationAdapter, and
// useClearWellToFacilityNetwork to ensure consistent layer references.

/** Line layer showing the well-to-facility network connections. */
export const WELL_NETWORK_MAP = "well-network-map";

/** GeoJSON source/layer for the primary highlighted facility icon. */
export const HIGHLIGHTED_FACILITY = "highlighted-facility";

/** Symbol layer for highlighted network facilities with depth-based coloring. */
export const HIGHLIGHTED_NETWORK_FACILITIES = "highlighted-network-facilities";

/** Title used for the network depth legend in the Zustand store. */
export const NETWORK_DEPTH_LEGEND_TITLE = "Network Depth";
